<mat-tab-group mat-stretch-tabs ngClass.xs="xs">
    <mat-tab>
        <ng-template mat-tab-label i18n> Library </ng-template>
        <ng-template matTabContent>
            <app-resource-library
                [selection]="selection"
                [type_scope_id]="AppScope.TEST"
                (select)="add.emit($event)"
            ></app-resource-library>
        </ng-template>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label i18n> My tests </ng-template>
        <ng-template matTabContent>
            <app-resource-library
                [selection]="selection"
                [type_scope_id]="AppScope.TEST"
                context="author"
                (select)="add.emit($event)"
            ></app-resource-library>
        </ng-template>
    </mat-tab>
    <mat-tab *ngIf="isAdmin$ | async">
        <ng-template mat-tab-label i18n> Create new test </ng-template>
        <app-create-test [publishOnly]="true" (published)="add.emit($event.res)"></app-create-test>
    </mat-tab>
</mat-tab-group>
